export default {
  /**
   * Mapa de favoritos conocidos localmente.
   * Clave: 'contentType:id'  |  Valor: boolean
   *
   * Solo contiene ítems que el usuario interactuó en esta sesión.
   * Si una clave no existe → se usa el valor que devolvió la API.
   */
  favorites: {},
}
